module.exports = __webpack_public_path__ + "media/customizations/sunterra/logo-c57b15ea5e92f67ce17b55b506f08e18.png";